export const meta = {
  id: 'M12',
  slug: 'utilizar-acordos',
  title: 'Como utilizar Acordos',
  description: 'Transforme decisões da Mentoria em compromissos claros e acompanháveis.',
  profile: 'mentor',
  category: 'mentorias',
  type: 'task',
  status: 'published',
  order: 330,
  keywords: ['acordos', 'mentoria', 'compromissos', 'próximos passos', 'ação', 'acompanhamento'],
  previous: 'M11',
  next: 'M13',
  related: ['M10', 'M13', 'A12'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Como utilizar Acordos

Acordos transformam decisões da Mentoria em próximos passos concretos.

## Um bom Acordo esclarece

- **o que** será feito;
- **quem** é responsável;
- qual é o resultado esperado;
- como o avanço poderá ser acompanhado.

## Como usar

<Steps>
  <Step title="Defina o próximo passo">
    Registre uma ação clara, evitando acordos vagos como “melhorar” ou “se esforçar mais”.
  </Step>
  <Step title="Conecte ao desenvolvimento">
    Relacione o Acordo ao objetivo, competência, Plano ou desafio discutido na sessão.
  </Step>
  <Step title="Acompanhe a execução">
    Na próxima interação, observe se houve ação, Evidência ou mudança de progresso.
  </Step>
  <Step title="Retome na próxima Mentoria">
    Use o resultado do Acordo como ponto de continuidade, não como simples cobrança.
  </Step>
</Steps>

## Ciclo do Acordo

**Acordo → ação → Evidência/progresso → próxima conversa.**

<Callout type="tip">
  Quanto mais claro o próximo passo, mais fácil será para Mentor e mentorado reconhecerem avanço, dificuldade ou necessidade de ajuste.
</Callout>

<HelpImage alt="Acordos de Mentoria registrados" pendingId="M12.1" />
